export const dateOrNull = (dateString?: string | null) => {
  if (dateString) return new Date(dateString);
  return null;
};
